import { Navigate, useParams } from 'react-router-dom';

// A route retired by DR-23 that must keep resolving. Existing inbound links, search
// results and printed material still point at these paths, so they redirect rather
// than 404.
//
// `replace` so the retired URL does not sit in history — a user pressing Back would
// otherwise bounce straight back into the redirect.
export function RetiredRoute({
  to,
  carryParam,
  as,
}: {
  to: string;
  /** Route param to carry across, e.g. the category id. */
  carryParam?: string;
  /** Query key it becomes on the destination. */
  as?: string;
}) {
  const params = useParams();
  const value = carryParam ? params[carryParam] : undefined;
  const target = value && as ? `${to}?${as}=${encodeURIComponent(value)}` : to;
  return <Navigate to={target} replace />;
}
